import * as yup from "yup";

import {
    mobileValidationByCountryCode,
    postalCodeValidation
} from "@sisuwellness/utilities/Validation/UserProfileValidation";
import { ERROR_MESSAGES } from "constants/messages";
import { COUNTRIES } from "@sisuwellness/utilities/User/UserProfile";
import i18n from "../../i18n.js";

export const validateSchema = payload => {
    const options = {
        message: {
            [COUNTRIES.UNITED_KINGDOM]: i18n.t(ERROR_MESSAGES.VALIDATION.MOBILE_NUMBER.UNITED_KINGDOM)
        }
    };

    return yup.object().shape({
        postalCode: postalCodeValidation(payload.postalCode, payload.countryCode),
        countryCode: yup.string().required(),
        mobileNumber: mobileValidationByCountryCode(payload.countryCode, options)
    });
};
